export function normalizePrerenderPath(pathname: string): string {
  const pathOnly = pathname.split(/[?#]/, 1)[0] || '/';
  const withLeadingSlash = pathOnly.startsWith('/') ? pathOnly : `/${pathOnly}`;
  return withLeadingSlash.replace(/\/+$/, '') || '/';
}

export function shouldHydratePrerenderedRoot({
  rootHasChildren,
  currentPathname,
  prerenderedRoute,
  prerenderedRoutes,
}: {
  rootHasChildren: boolean;
  currentPathname: string;
  prerenderedRoute: string | null;
  prerenderedRoutes: Iterable<string>;
}): boolean {
  if (!rootHasChildren) return false;

  const currentPath = normalizePrerenderPath(currentPathname);
  if (prerenderedRoute) {
    return normalizePrerenderPath(prerenderedRoute) === currentPath;
  }

  const normalizedRoutes = new Set(Array.from(prerenderedRoutes, normalizePrerenderPath));
  return normalizedRoutes.has(currentPath);
}
